/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GroupMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABoElEQVR4nOVSS0oDQRAdUC+gIojgRtAT+EGEHCDTVTVgp2o0Lh1xI+QQHsGTKC5ciTHiJmTl0qVI/CSIHzCgkZ7M5J9MEsaFWDA0Nd393qv32rL+XSkntaaIr4HkHZCvTB8buONszyriMpBUGx+/mP+xEQDKfSuBVBXxvhVX2baeB+TbWAiI3BVFkgPiN7Oa3idxUstA8h2Al0eyyLeDuNTmdykEA+QznxxkdST1iO5eu9eBYs+KowxQNwIg2fUnAAFFfKeQTxSJq7Uei9ui85Y9lDwRLwxFYkIFlEuF8mpWE259QuRix3QoD0OT9CpFklYon11I8pF2eZ43gchbgHJqVPnhojyb3gCHADa5G+F+60MQtyc4gF5SxIUeAVeDl1Qg4kVzHpHXFXKlbYrjruDmEhA/9gOHkAS56DjpGV+UIwcK+atpgpsO8EQiMR6lHGrAFQDJ2LY7PXRogygHkMxQwHXvTaADEBDtTAWCcpHnkbPNBMFr4KN+l7TWk7XznI20k+SiYRHKhwkqmdRzv2MRyWHIqJCfIkLeHInkT9YPBIactgUPBPgAAAAASUVORK5CYII=)
 */
export const GroupMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.5 8a3 3 0 1 0-2.7-4.3c-.2.4.06.86.44 1.12a5 5 0 0 1 2.14 3.08c.01.06.06.1.12.1ZM18.17 16a.52.52 0 0 1-.45-.26 9.55 9.55 0 0 0-3.1-3.25c-.53-.33-.71-1.05-.48-1.63.11-.27.2-.57.26-.87.11-.54.55-1 1.1-.92a7.5 7.5 0 0 1 6.43 6.4c.04.28-.2.53-.48.53h-3.28ZM15.19 15.61c.13.16.02.39-.19.39a3 3 0 0 0-1.52 5.59c.2.12.26.41.02.41h-8a.5.5 0 0 1-.5-.5v-2.1c0-.25-.31-.33-.42-.1-.32.67-.67 1.58-.88 2.54a.2.2 0 0 1-.2.16A1.5 1.5 0 0 1 2 20.5a7.5 7.5 0 0 1 13.19-4.89ZM9.5 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM15.5 22Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
